import { RequestMethod } from '@lib/api/consts'
import internalJsonFetch from '@lib/api/internalJsonFetch'
import ApiRoutes from '@lib/routes/ApiRoutes'
import type { TrialLocationNarrow } from '@modules/trials/types/TrialAssociatedWithLocations'

export type TrialLocationInfo = {
  locationCount: number
  nearestTrialLocations: TrialLocationNarrow[]
}

export default async function getTrialLocationsNearLatLng({
  latlng,
  slug,
}: {
  latlng: { latitude: number; longitude: number }
  slug: string
}): Promise<NonNullable<TrialLocationInfo>> {
  const response = await internalJsonFetch<TrialLocationInfo>({
    authenticated: false,
    requestMethod: RequestMethod.GET,
    url: ApiRoutes.v1.trials.locations.near.latlng(slug, latlng),
  })

  if (!response.success || !response.data) {
    return {
      locationCount: 0,
      nearestTrialLocations: [],
    }
  }

  return {
    locationCount: response.data.locationCount,
    nearestTrialLocations: response.data.nearestTrialLocations,
  }
}
